<div class="main__container">
	<breadcrumb title="Cumpleaños"></breadcrumb>
	<div class="section__container">
		<div *ngIf="{ cumplesReady: cumplesReady$ | async, cumplesTotal: cumplesTotal$ | async } as data" class="box__container titulo__container">
			<div class="titulo">
				<div>
					<div>Cumpleaños</div>
					<div *ngIf="data.cumplesReady" class="cantidad__cumples">
						<ng-container *ngIf="data.cumplesTotal >= 0">{{data.cumplesTotal}} cumpleaños encontrados</ng-container>
					</div>
				</div>
				<ng-container [ngTemplateOutlet]="filters"></ng-container>
			</div>
		</div>

		<div class="contenido__box">
			<div class="contenido__container">
				<ng-container *ngIf="cumplesReady$ | async as cumplesReady; else loading" [ngTemplateOutlet]="cumpleCards"></ng-container>
			</div>
		</div>
	</div>
</div>

<!-- Tarjeta cumpleaños -->
<ng-template #cumpleCards>
	<div *ngIf="{ cumples: cumples$ | async, envioReady: envioReady$ | async, cumpleFotoFunc: cumpleFotoFunc$ | async,
			funciones: funciones$ | async, funcionesReady: funcionesReady$ | async } as data" class="cumples-card">
		<ng-container *ngFor="let personaCumple of data.cumples; let isLast = last; let i = index; let showInput = true;">
			<!-- Fila con datos del cumpleañero -->
			<ng-container *ngIf="data.cumpleFotoFunc( personaCumple.idUsuarioMf ) as fotoData; else usuarioFotoPreviewDefault">
				<ng-container *ngIf="fotoData.found; else usuarioFotoPreviewDefault">
					<img [src]="fotoData.foto" class="usuario-foto usuario-foto--preview">
				</ng-container>
			</ng-container>
			<div>
				<!-- Nombre e info -->
				<div class="name">
					<div>{{personaCumple.apellidos}}, {{personaCumple.nombres}}</div>
					<div ngbDropdown placement="bottom" (openChange)="onPersonaInfoSelected( $event, personaCumple.idUsuarioMf )" gtagEvent="alternar-informacion" gtagCategory="cumples">
						<div ngbDropdownToggle class="info"></div>
						<div ngbDropdownMenu class="info-persona__container">
							<ng-container [ngTemplateOutlet]="infoPersona"
								[ngTemplateOutletContext]="{ persona: personaCumple, cumpleFotoFunc: data.cumpleFotoFunc, funciones: data.funciones, funcionesReady: data.funcionesReady }">
							</ng-container>
						</div>
					</div>
				</div>
				<!-- Áreas -->
				<div *ngIf="personaCumple.areas.length > 0" class="areas">
					<div>{{personaCumple.areas[0].nombre}}</div>
					<div *ngIf="personaCumple.areas.length > 1">
						+{{personaCumple.areas.length - 1}}
						<ng-container *ngIf="personaCumple.areas.length - 1 == 1"> área</ng-container>
						<ng-container *ngIf="personaCumple.areas.length - 1 > 1"> áreas</ng-container>
					</div>
				</div>
				<!-- Último mensaje enviado -->
				<div *ngIf="personaCumple.fechaUltimoMensajeAsDesc" class="enviado">Último mensaje enviado el {{personaCumple.fechaUltimoMensajeAsDesc}}</div>
			</div>
			<!-- Botón enviar mensaje -->
			<div class="aplicar__container">
				<ng-container *ngIf="personaCumple.email && personaCumple.email.length > 0; else sinEmail">
					<button *ngIf="formIdUsuarioMf != personaCumple.idUsuarioMf" [disabled]="!data.envioReady" class="btn aplicar enviar__mensaje" (click)="toggleCollapse( personaCumple.idUsuarioMf )"
						gtagEvent="preparar-saludo" gtagCategory="cumples">Enviar mensaje</button>
				</ng-container>
			</div>

			<!-- Fila que contiene el formulario y se despliega sólo si el usuario desea enviar un saludo-->
			<div class="salutacion__container">
				<ng-container [ngTemplateOutlet]="formMensaje" [ngTemplateOutletContext]="{ idUsuarioMf: personaCumple.idUsuarioMf, envioReady: data.envioReady }"></ng-container>
			</div>

			<!-- Separador-->
			<div *ngIf="!isLast" class="sep"></div>
		</ng-container>
	</div>
</ng-template>

<!-- Form mensaje -->
<ng-template #formMensaje let-idUsuarioMf="idUsuarioMf" let-envioReady="envioReady">
	<form [formGroup]="messageForm" autocomplete="off" novalidate class="form-mensaje" [@smoothCollapse]="formIdUsuarioMf == idUsuarioMf? 'expanded': 'collapsed'">
		<textarea class="input-text" name="message" placeholder="Envía tu saludo por email desde aquí" formControlName="message"></textarea>
		<div class="button-container">
			<input type="button" [disabled]="!envioReady" value="Cancelar" class="btn aplicar form__button" (click)="toggleCollapse( idUsuarioMf )"
				gtagEvent="cancelar-saludo" gtagCategory="cumples">
			<input type="submit" [disabled]="!messageForm.valid || !envioReady" value="Enviar" class="btn enviar form__button" (click)="onSendMessage( idUsuarioMf )"
				gtagEvent="enviar-saludo" gtagCategory="cumples">
		</div>
	</form>
</ng-template>

<!--Encabezado filtros-->
<ng-template #filters >
	<div *ngIf="{ filterReady: filterReady$ | async, filterDates: filterDates$ | async, cumplesReady: cumplesReady$ | async, today: cumplesToday$ | async } as data">
		<ng-container *ngIf="data.filterReady; else loading">
			<div #filterDropdown ngbDropdown placement="bottom-right" class="calendar__container" gtagEvent="alternar-calendario" gtagCategory="cumples">
				<input readonly #filterDate ngbDropdownToggle class="filter" [value]="data.filterDates.startDate" [disabled]="!data.cumplesReady">
				<input type="button" class="calendar" (click)="onCalendarSelected()" [disabled]="!data.cumplesReady">
				<div ngbDropdownMenu class="datepicker__container">
					<datepicker #datepicker navigation="select" [today]="toDateStruct( data.today )" [minDate]="toDateStruct( data.filterDates.minDate )"
						[maxDate]="toDateStruct( data.filterDates.maxDate )" [startDate]="toDateStruct( data.filterDates.startDate )"></datepicker>
				</div>
			</div>
		</ng-container>
	</div>
</ng-template>

<!-- Persona Info -->
<ng-template #infoPersona let-persona="persona" let-cumpleFotoFunc="cumpleFotoFunc" let-funciones="funciones" let-funcionesReady="funcionesReady">
	<div class="info-persona">
		<!-- Foto persona -->
		<ng-container *ngIf="cumpleFotoFunc( persona.idUsuarioMf ) as fotoData; else usuarioFotoBigDefault">
			<ng-container *ngIf="fotoData.found; else usuarioFotoBigDefault">
				<img [src]="fotoData.foto" class="usuario-foto usuario-foto--big">
			</ng-container>
		</ng-container>
		<!-- Información de la persona-->
		<div class="info-data">
			<div class="name">{{persona.apellidos}}, {{persona.nombres}}</div>
			<div class="email">{{persona.email}}</div>

			<ul ngbNav #info="ngbNav" class="nav-tabs">
				<li ngbNavItem>
					<a ngbNavLink>Áreas de trabajo</a>
					<ng-template ngbNavContent>
						<ul class="items">
							<li *ngFor="let area of persona.areas">{{area.nombre}}</li>
						</ul>
					</ng-template>
				</li>
				<li ngbNavItem>
					<a ngbNavLink>Cargos o funciones</a>
					<ng-template ngbNavContent>
						<ul *ngIf="funcionesReady; else loading" class="items">
							<li *ngFor="let funcion of funciones">{{funcion.nombre}}</li>
						</ul>
					</ng-template>
				</li>
			</ul>
			<div [ngbNavOutlet]="info"></div>
		</div>
	</div>
</ng-template>

<!-- Loading -->
<ng-template #loading>
	<div class="loading">
		<loading></loading>
	</div>
</ng-template>

<!-- Foto preview default-->
<ng-template #usuarioFotoPreviewDefault>
	<img class="usuario-foto usuario-foto--default usuario-foto--preview">
</ng-template>

<!-- Foto big default-->
<ng-template #usuarioFotoBigDefault>
	<img class="usuario-foto usuario-foto--default usuario-foto--big">
</ng-template>

<!-- Sin email -->
<ng-template #sinEmail>
	<div class="sin-email">La persona no cuenta con correo electrónico</div>
</ng-template>